import React from "react";

import ShipmentBoxesTableRow from "./ShipmentBoxesTableRow";

const ShipmentBoxesTableBody = ({
  disabled,
  options = [],
  remove = () => {},
  fields = [],
}) => {
  return (
    <>
      {fields?.map((item, idx) => (
        <ShipmentBoxesTableRow
          key={item.id}
          idx={idx}
          item={item}
          remove={remove}
          disabled={disabled}
          options={options}
        />
      ))}
    </>
  );
};

export default ShipmentBoxesTableBody;
